import { render, staticRenderFns } from "./phoneNumberDatabaseDetail.vue?vue&type=template&id=27866bd3&scoped=true"
import script from "./phoneNumberDatabaseDetail.vue?vue&type=script&lang=js"
export * from "./phoneNumberDatabaseDetail.vue?vue&type=script&lang=js"
import style0 from "./phoneNumberDatabaseDetail.vue?vue&type=style&index=0&id=27866bd3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27866bd3",
  null
  
)

export default component.exports